import React, { FC, useState } from 'react';
import styled from 'styled-components';

import Row from '../layout/Row';
import ColumnItem from '../layout/ColumnItem';
import SectionContainer from './SectionContainer';
import Spacer from '../layout/Spacer';
import { P } from '../font/Parargraph';
// import NavMenuItem from '../navigation/NavMenuItem';

export type GenderType = 'male' | 'female';

type ImageAnswerProps = {
  sectionTitle: string;
  firstImageTitle: string;
  firstImage: string;
  firstImageChanged: (value: string) => void;
  resetFirstImage: () => void;
  secondImageTitle: string;
  secondImage: string;
  secondImageChanged: (value: string) => void;
  resetSecondImage: () => void;
  thirdImage: string;
  thirdImageTitle: string;
  thirdImageChanged: (value: string) => void;
  resetThirdImage: () => void;
};

const ImageAnswer: FC<ImageAnswerProps> = ({
  sectionTitle,
  firstImageTitle,
  firstImage,
  firstImageChanged,
  resetFirstImage,
  secondImageTitle,
  secondImage,
  secondImageChanged,
  resetSecondImage,
  thirdImageTitle,
  thirdImage,
  thirdImageChanged,
  resetThirdImage,
}) => {
  // const [selectedTab, setSelectedTab] = useState<GenderType>('male');
  const [firstImageHasError, setFirstImageHasError] = useState(false);
  const [secondImageHasError, setSecondImageHasError] = useState(false);
  const [thirdImageHasError, setThirdImageHasError] = useState(false);

  const imageError = 'The image';

  const renderForm = () => (
    <>
      <Row>
        <ColumnItem>
          <s-text-field
            id='firstImage'
            name='firstImage'
            label={firstImageTitle}
            value={firstImage}
            onInput={(event) => {
              if (!firstImageHasError) {
                firstImageChanged(event.currentTarget.value);
              }
            }}
            onBlur={() => setFirstImageHasError(firstImage === '')}
            error={firstImageHasError ? imageError : ''}
            autocomplete='off'
          />
          <s-button variant='tertiary' onClick={resetFirstImage}>
            Reset to default
          </s-button>
        </ColumnItem>
      </Row>
      <Row>
        <ColumnItem>
          <s-text-field
            id='secondImage'
            name='secondImage'
            label={secondImageTitle}
            value={secondImage}
            onInput={(event) => {
              if (!secondImageHasError) {
                secondImageChanged(event.currentTarget.value);
              }
            }}
            onBlur={() => setSecondImageHasError(secondImage === '')}
            error={secondImageHasError ? imageError : ''}
            autocomplete='off'
          />
          <s-button variant='tertiary' onClick={resetSecondImage}>
            Reset to default
          </s-button>
        </ColumnItem>
      </Row>
      <Row>
        <ColumnItem>
          <s-text-field
            id='thirdImage'
            name='thirdImage'
            label={thirdImageTitle}
            value={thirdImage}
            onInput={(event) => {
              if (!thirdImageHasError) {
                thirdImageChanged(event.currentTarget.value);
              }
            }}
            onBlur={() => setThirdImageHasError(thirdImage === '')}
            error={thirdImageHasError ? imageError : ''}
            autocomplete='off'
          />
          <s-button variant='tertiary' onClick={resetThirdImage}>
            Reset to default
          </s-button>
        </ColumnItem>
      </Row>
    </>
  );

  const renderSetting = () => (
    <>
      <Row>
        <ColumnItem>
          <s-heading fontSize='large'>{sectionTitle}</s-heading>
          <Spacer height={8} />
        </ColumnItem>
      </Row>
      <Spacer height={16} />
      {renderForm()}
    </>
  );

  const renderPreview = () => (
    <PreviewContainer>
      <ImageContainer>
        <img src={firstImage} width={64} height={84} alt='' />
        <Spacer height={8} />
        <P>{firstImageTitle}</P>
      </ImageContainer>
      <Spacer width={20} />
      <ImageContainer>
        <img src={secondImage} width={64} height={84} alt='' />
        <Spacer height={8} />
        <P>{secondImageTitle}</P>
      </ImageContainer>
      <Spacer width={20} />
      <ImageContainer>
        <img src={thirdImage} width={64} height={84} alt='' />
        <Spacer height={8} />
        <P>{thirdImageTitle}</P>
      </ImageContainer>
    </PreviewContainer>
  );

  return (
    <SectionContainer
      renderSettingsForm={renderSetting}
      renderPreview={renderPreview}
    />
  );
};

export default ImageAnswer;

const PreviewContainer = styled.div`
    display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
    padding: 20px 64px;
  background-color: white
  text-align: center;
`;

const ImageContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;
